exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".map-presentation[data-v-0e9094a0]{stroke:#fff;stroke-linejoin:round;stroke-width:8px}", ""]);
